/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GenericDropdownItem_String_String } from '../models/GenericDropdownItem_String_String';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class EsppDropdownService {

    /**
     * @returns GenericDropdownItem_String_String OK
     * @throws ApiError
     */
    public static getApiAwardApiAppEsppDropdownEsppEligibilityStatusOptions(): CancelablePromise<Array<GenericDropdownItem_String_String>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/espp-dropdown/espp-eligibility-status-options',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns GenericDropdownItem_String_String OK
     * @throws ApiError
     */
    public static getApiAwardApiAppEsppDropdownEnrollmentStatusOptions(): CancelablePromise<Array<GenericDropdownItem_String_String>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/espp-dropdown/enrollment-status-options',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns GenericDropdownItem_String_String OK
     * @throws ApiError
     */
    public static getApiAwardApiAppEsppDropdownOfferingPeriodTypes(): CancelablePromise<Array<GenericDropdownItem_String_String>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/espp-dropdown/offering-period-types',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
